import { ModelHelper as UtilitiesModelHelper } from '@dentsply-sirona/utilities';

/**
 * Model helper
 */
export class ModelHelper extends UtilitiesModelHelper {
	/**
	 * Deeply update an object
	 *
	 * HINT: Only existing properties are updated
	 *
	 * @param obj - Object to be updated
	 * @param data - Data with which the existing object is to be updated
	 */
	public static updateExistingProperties(obj: any, data: any) {
		// If object (as value) does not exist, remove it (set to undefined)
		if (obj === undefined) {
			return undefined;

			// If no new data is available, keep the current
		} else if (data === undefined) {
			return obj;

			// If the new data is set to zero (to be deleted on the server) or is an array, use the new data
		} else if (obj === null || Array.isArray(data)) {
			return data;

			// If both the current and the new data are an object, a recursive update is performed
		} else if (typeof obj === 'object' && typeof data === 'object') {
			const tmp = {};
			for (const [key, value] of Object.entries(obj)) {
				tmp[key] = ModelHelper.updateExistingProperties(value, data[key]);
			}

			// If the object is empty, it is replaced by null
			if (Object.keys(tmp).length === 0) {
				return null;
			} else {
				return tmp;
			}

			// In all other cases (for example, for primitive types), data is used
		} else {
			return data;
		}
	}

	/**
	 * Deeply intersection of objects
	 *
	 * HINTs:
	 * - only properties that are present in both objects are retained (only the intersection is used)
	 * - the second object overwrites the values of the first one
	 *
	 * @param obj - Object to be updated
	 * @param data - Data with which the existing object is to be updated
	 */
	public static intersection(obj: any, data: any) {
		// Only the intersection is used
		if (obj === undefined || data === undefined) {
			return undefined;

			// If the new data is set to zero (to be deleted on the server) or is an array, use the new data
		} else if (obj === null || Array.isArray(data)) {
			return data;

			// If both the current and the new data are an object, a recursive update is performed
		} else if (typeof obj === 'object' && typeof data === 'object') {
			const tmp = {};
			for (const [key, value] of Object.entries(obj)) {
				tmp[key] = ModelHelper.intersection(value, data[key]);
			}

			// If the object is empty, it is replaced by null
			if (Object.keys(tmp).length === 0) {
				return null;
			} else {
				return tmp;
			}

			// In all other cases (for example, for primitive types), data is used
		} else {
			return data;
		}
	}
}
